<div
    matSnackBarLabel
    style="
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
        max-width: 700px;
        margin: 16px;
    "
>
    {{ message }}
</div>
<span matSnackBarActions>
    <button mat-button matSnackBarAction (click)="onDetailsButtonClick()" style="white-space: nowrap; min-width: initial">
        Klik hier voor details
    </button>
    <button mat-button matSnackBarAction class="rax-icon-button" (click)="onCloseSnackbarButtonClick()">x</button>
</span>
